export const errorStatuses = [400, 401, 403, 404, 500];
